import React from 'react';
import ReactDOM from 'react-dom';
import { Fragment, useEffect } from 'react';
import {
  AuthenticationProvider,
  InMemoryWebStorage,
} from '@axa-fr/react-oidc-context';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import { AppContainer, setConfig } from 'react-hot-loader';
import { NotificationContainer } from 'react-notifications';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './contexts/AuthContext';
import NextApp from './NextApp';

let authProviderRef: React.Ref<any>;
export const getAuthProviderState = () => authProviderRef;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

// should be remove:
setConfig({ showReactDomPatchNotification: false });

const oidcConfiguration = {
  client_id: window.config.clientId,
  response_type: 'code',
  post_logout_redirect_uri: window.config.logoutRedirectUri
    ? window.config.logoutRedirectUri
    : 'https://www.faragostar.net/',
  scope: window.config.scope,
  authority: window.config.authority,
  automaticSilentRenew: true,
  loadUserInfo: true,
  redirect_uri: `${window.location.origin}/signin-callback`,
  silent_redirect_uri: `${window.location.origin}/silent-renew`,
};

const CustomCallback = () => {
  useEffect(() => {
    Nprogress.start();

    return () => {
      Nprogress.done();
    };
  }, []);

  // useEffect(() => {
  //   Object.keys(localStorage).map((lsKey) => {
  //     if (lsKey.includes("oidc")) {
  //       let oidcData = JSON.parse(localStorage[lsKey]);
  //       if (oidcData.data) {
  //         oidcData.data.url = "/team-work/home";
  //         localStorage.setItem(lsKey, JSON.stringify(oidcData));
  //       }
  //     }
  //   });
  // });

  return <div />;
};

const CustomComponent = () => {
  useEffect(() => {
    Nprogress.start();

    window.location.href = '/team-work/home';
    return () => {
      Nprogress.done();
    };
  }, []);

  return <div></div>;
};

// Wrap the rendering in a function:
const render = (Component: React.FC) => {
  ReactDOM.render(
    // Wrap App inside AppContainer
    <AppContainer>
      <AuthProvider>
        <AuthenticationProvider
          configuration={oidcConfiguration}
          // loggerLevel={oidcLog.DEBUG}
          notAuthenticated={CustomComponent}
          notAuthorized={CustomComponent}
          isEnabled={true}
          callbackComponentOverride={CustomCallback}
          UserStore={InMemoryWebStorage}
          authenticating={CustomCallback}
          sessionLostComponent={CustomCallback}
        >
          <QueryClientProvider client={queryClient}>
            <Fragment>
              <Component />
              <NotificationContainer />
            </Fragment>
          </QueryClientProvider>
        </AuthenticationProvider>
      </AuthProvider>
    </AppContainer>,
    document.getElementById('root'),
  );
};

// Do this once
// registerServiceWorker();

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render(NextApp);
  });
}
